import React from "react";
import { Card } from "./ui/card";

export function KpiCard({ label, value, unit, sub, tone = "ink", icon: Icon, testid }) {
  const toneCls = {
    ink: "text-ink",
    primary: "text-primary",
    critical: "text-critical",
    warning: "text-warning",
    success: "text-success",
  }[tone];

  return (
    <Card className="p-4 hover:border-lineFocus group" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-wider text-muted">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${toneCls} opacity-70`} />}
      </div>
      <div className="mt-3 flex items-baseline gap-1.5">
        <span className={`mono text-3xl font-semibold tracking-tighter ${toneCls}`}>{value}</span>
        {unit && <span className="mono text-sm text-muted">{unit}</span>}
      </div>
      {sub && <div className="mt-1 text-xs text-faint">{sub}</div>}
    </Card>
  );
}
